export enum ComboType {
  Spk = 'SPK',
  OdbToAligner = 'ODB_TO_ALIGNER',
}
